export default __webpack_public_path__ + "static/media/thumbnail_5.9a04e034.webp";